var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profile)?_c('div',{staticClass:"job-intro"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.$translate('JOB_INTRODUCE'))}}),_c('div',{staticClass:"intro",domProps:{"innerHTML":_vm._s(_vm.jobIntro)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }